import { ActivityEntityName } from '@jms/model/entities';
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { ContactMergeData, ContactMergeSchema } from './contact.merge.data';

@MergeSchema({
    entity: ActivityEntityName.Equipment,
    name: 'EquipmentMergeDataSchema',
})
export class EquipmentMergeData {
    @MergeField()
    name: string;

    @MergeField({
        displayName: 'Equipment #',
    })
    equipmentNumber: string;

    @MergeField({
        displayName: 'Serial #',
    })
    serialNumber: string;

    @MergeField({
        displayName: 'Internal',
    })
    internalNumber: string;

    @MergeField()
    make: string;

    @MergeField()
    model: string;

    @MergeField()
    class: string;

    @MergeField()
    type: string;

    @MergeField({
        nestedFieldSchema: ContactMergeSchema
    })
    addedBy: ContactMergeData;

    @MergeField()
    addedOn: Date;

    @MergeField({
        nestedFieldSchema: ContactMergeSchema
    })
    removeBy: ContactMergeData;

    @MergeField()
    removedOn: Date;

    @MergeField()
    totalHours: string;

    @MergeField()
    totalDays: string;

    @MergeField()
    totalWeeks: string;

    @MergeField({
        displayName: 'Rego #',
    })
    registration: string;
}

export const EquipmentMergeDataSchema = getSchema(EquipmentMergeData);

@MergeSchema({
    entity: ActivityEntityName.Equipment,
})
export class EquipmentArrayMergeData {
    @MergeField({
        arraySchemaName: "EquipmentMergeDataSchema"
    })
    equipments: EquipmentMergeData[];
}

export const EquipmentArrayMergeDataSchema = getSchema(EquipmentArrayMergeData);